<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Header from './view/Header';
export default {
  // components: {
  //   Header
  // }
  created() {
    // 当vuex中没有用户登录数据时，在localStorage.getItem("supUser");取
    if (!this.$store.state.supUser.id) {
      console.log("------执行-------");
      var supUser = JSON.parse(localStorage.getItem("supUser"));
      this.$store.commit("updateRole", supUser); //将用户数据存到vuex
      console.log(this.$store.state.supUser);
    }
  }
};
</script>

<style>
#app {
  background: linear-gradient(180deg, #f0f5fc 0%, #f4f5f7 100%);
  /* background: linear-gradient(to bottom right, #1d3b45, #0a1b37); */
  height: 100%;
}
</style>
